type LocationBoostOption = {
  value: number;
  title: string;
  price: string;
};
export const locationBoostOptions: LocationBoostOption[] = [
  {
    value: 1,
    title: '1 week',
    price: '$25',
  },
  {
    value: 2,
    title: '2 weeks',
    price: '$40',
  },
  {
    value: 4,
    title: '4 weeks',
    price: '$50',
  },
];
